import { useEffect, useState } from 'react'

export const useBalance = (value) => {
  const [displayValue, setDisplayValue] = useState(0)

  useEffect(() => {
    setDisplayValue(value / 1000000)
  }, [value])

  return {
    displayValue,
    value
  }
}